module.exports = __webpack_public_path__ + "static/media/2.303f41c4.jpg";